export const TRANSFER_SHEET_THUMBNAILS_COUNT = 3;
